(function () {
  const state =
    window.__velaniMuseCartReservationTimer =
      window.__velaniMuseCartReservationTimer || {
        key: null,
        endTime: null,
        interval: null,
        expired: false
      };

  function getSavedEndTime(key) {
    try {
      return Number(sessionStorage.getItem(key)) || 0;
    } catch (error) {
      return 0;
    }
  }

  function saveEndTime(key, endTime) {
    try {
      sessionStorage.setItem(key, String(endTime));
    } catch (error) {
      /*
       * Si el navegador bloquea sessionStorage,
       * el contador seguirá funcionando durante esta visita.
       */
    }
  }

  function updateTimer() {
    const timerElement = document.querySelector(
      '[data-cart-reservation-timer]'
    );

    /*
     * El carrito todavía no está abierto.
     * El MutationObserver volverá a ejecutar esta función
     * cuando Shopify inserte el cart drawer.
     */
    if (!timerElement) {
      return;
    }

    const banner = timerElement.closest(
      '[data-cart-reservation-banner]'
    );

    const configuredMinutes = Number(
      banner?.dataset.cartReservationMinutes || 10
    );

    const minutes = Math.max(
      1,
      Number.isFinite(configuredMinutes)
        ? configuredMinutes
        : 10
    );

    const storageKey = 'cartReservationEnd_' + minutes;
    const now = Date.now();

    /*
     * El contador solo se crea una vez.
     * Si Shopify reconstruye el carrito, mantiene
     * exactamente el mismo tiempo restante.
     */
    if (state.key !== storageKey) {
      state.key = storageKey;
      state.expired = false;

      const savedEndTime = getSavedEndTime(storageKey);

      if (savedEndTime > now) {
        state.endTime = savedEndTime;
      } else {
        state.endTime = now + minutes * 60 * 1000;
        saveEndTime(storageKey, state.endTime);
      }
    }

    const remainingMilliseconds = Math.max(
      0,
      state.endTime - Date.now()
    );

    const remainingSeconds = Math.ceil(
      remainingMilliseconds / 1000
    );

    const minutesLeft = Math.floor(
      remainingSeconds / 60
    ).toString().padStart(2, '0');

    const secondsLeft = (
      remainingSeconds % 60
    ).toString().padStart(2, '0');

    /*
     * Busca todos los contadores actuales.
     * Esto permite que funcione aunque Shopify
     * reemplace el contenido del cart drawer.
     */
    document
      .querySelectorAll('[data-cart-reservation-timer]')
      .forEach(function (element) {
        element.textContent =
          minutesLeft + ':' + secondsLeft;
      });

    if (remainingMilliseconds <= 0) {
      state.expired = true;

      if (state.interval) {
        clearInterval(state.interval);
        state.interval = null;
      }

      return;
    }

    /*
     * Solo se permite un intervalo activo.
     * Así evitamos contadores duplicados.
     */
    if (!state.interval) {
      state.interval = setInterval(
        updateTimer,
        1000
      );
    }
  }

  function startTimer() {
    if (!state.expired) {
      updateTimer();
    }
  }

  /*
   * Intenta iniciar el contador al cargar la página.
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startTimer
    );
  } else {
    startTimer();
  }

  /*
   * Shopify inserta el cart drawer dinámicamente.
   * Este observer detecta cuándo aparece sin necesitar
   * que el cliente recargue la página.
   */
  const observer = new MutationObserver(function () {
    if (!state.interval && !state.expired) {
      updateTimer();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
